export enum DocumentType {
  W9 = "W_9",
  COI = "COI",
  VoidCheck = "VOID_CHECK",
}
